/**
 * Runs once per page load, before React hydrates.
 *
 * Its one job: tell the global waiting dialog that a page-to-page navigation
 * has started. The App Router calls `onRouterTransitionStart` for every
 * transition — a <Link> click, `router.push`, `router.replace`, back and
 * forward — which is the only place all of them can be heard from. Doing it
 * here is what lets every page get the wait without any page asking for it.
 *
 * `beginNavWait` ignores transitions that do not change the path, and the
 * dialog releases the hold when the pathname actually changes (GlobalWait.tsx).
 * See lib/wait.ts for the rest.
 */
import { beginNavWait } from '@/lib/wait';

export function onRouterTransitionStart(url: string, _navigationType: 'push' | 'replace' | 'traverse'): void {
  beginNavWait(url);
}
